module.exports = __webpack_public_path__ + "img/banner2.e66a5b74.png";